import { MediaImageInterface, MediaImageModel } from '@modules/media/models/media-image.model';
import { MediaStreamInterface, MediaStreamModel } from '@modules/media/models/media-stream.model';
import { MediaVideoInterface, MediaVideoModel } from '@modules/media/models/media-video.model';

import { SectionType } from '../enums/section-type.enum';

import { AnnouncementInterface, AnnouncementModel } from './announcement.model';

export enum AnnouncementBannerLayoutType {
  NORMAL = 'normal',
  SMALL = 'small_with_countdown',
  SMALL_WITHOUT_COUNTDOWN = 'small',
  NORMAL_COUNTDOWN_BELOW = 'normal_countdown_below',
  SMALL_COUNTDOWN_REAR = 'small_with_rear_countdown',
}
export interface AnnouncementBannerInterface {
  id: string;
  type: string;
  title: string;
  subtitle: string;
  fuelLabel: string;
  titleHash: string;
  layout: AnnouncementBannerLayoutType;
  background: MediaImageInterface | MediaVideoInterface;
  streams: {
    slug: string;
    stream: MediaStreamInterface;
  }[];
  teasers: AnnouncementInterface[];
  links: {
    label: string;
    link: string;
    queryParams?: {
      [key: string]: any;
    };
  }[];
}

export class AnnouncementBannerModel {
  type = SectionType.ANNOUNCEMENT;
  title: string;
  subtitle: string;
  fuelLabel: string;
  titleHash: string;
  layout: AnnouncementBannerLayoutType;
  links: {
    label: string;
    link: string;
    queryParams?: {
      [key: string]: any;
    };
  }[];
  activeStreamItem?: {
    slug: string;
    stream: MediaStreamModel;
  };
  streamItems: {
    slug: string;
    stream: MediaStreamModel | null;
  }[] = [];
  teasers: AnnouncementModel[] = [];
  singleAnnouncement?: AnnouncementModel;
  background!: MediaImageModel | MediaVideoModel;

  constructor(data: AnnouncementBannerInterface) {
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.fuelLabel = data.fuelLabel;
    this.titleHash = data.titleHash;
    this.layout = data.layout;
    this.links = data.links;
    if (data.background) {
      if (data.background.mediaType === 'video') {
        this.background = new MediaVideoModel(data.background as MediaVideoInterface);
      } else if (data.background.mediaType === 'image') {
        this.background = new MediaImageModel(data.background as MediaImageInterface);
      }
    }
    this.teasers = data.teasers.map((teaser) => new AnnouncementModel(teaser));
    this.singleAnnouncement = this.teasers.find((teaser) => !!teaser.countdownDate);
    this.streamItems = data.streams.map((stream) => {
      return {
        slug: stream.slug,
        stream: stream.stream ? new MediaStreamModel(stream.stream) : null,
      };
    });
  }
}
